export function useAttendance() {
  return {};
}
